module.exports = __webpack_public_path__ + "img/chocolate.8ddfd651.png";